<template>
  <ul class="ui_tab clearfix">
    <li v-for="(tabName, index) in computedItems" :key="tabName"
      :class="{ on: index === value }">
      <button type="button"
        @click="$emit('input', index)">
        {{ tabName }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'UiTab',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    computedItems () {
      return this.items.map(item => String(item))
    }
  }
}
</script>

<style lang="scss" scoped>
.ui_tab {
  &>li {
    float: left;
    margin-left: 30px;
    font-size: 15px;
    font-weight: 500;
    color: #999;
    border-bottom: 3px solid transparent;

    &:first-child {
      margin-left: 0
    }
    &.on {
      color: #2f2f2f;
      border-bottom: 3px solid #ec0047;
    }
    button {
      color: inherit;
      font-weight: 500;
    }
  }
}
</style>
